import languages from "config/languages";
import getPageUrl from "utils/getPageUrl";
import { checkIfPagePathExist, getParentLanguage } from "utils/localeUtils";
import { LOGOTYPES } from "./consts";

const LONG_COPY_BOTTOM_BAR_LANGUAGE = "de";
export const isLongCopyBottomBarLanguage = (language) => LONG_COPY_BOTTOM_BAR_LANGUAGE === getParentLanguage(language);

const NARROW_TEXT_LANGUAGES = ["en", "sv"];

const buildLanguageData = (langs, pageName, cmsLanguagesData) =>
  Object.keys(langs).reduce((obj, language) => {
    const languageObject = obj;
    let localizedPagePath = "";

    if (cmsLanguagesData && cmsLanguagesData.length) {
      const cmsPageData = cmsLanguagesData.filter((item) => item.full_slug.split("/")[0] === language);
      localizedPagePath = cmsPageData[0] ? `/${cmsPageData[0].full_slug}/` : `/${language}/`;
    } else {
      localizedPagePath = getPageUrl(language, pageName);
    }

    languageObject[language] = {
      languageCode: language,
      languageName: langs[language],
      href: localizedPagePath.replace(`//`, "/"),
      flag: languages.get(language).languageFlag,
    };

    return languageObject;
  }, {});

const getLocalizedLogotypes = (language) =>
  LOGOTYPES[language] || LOGOTYPES[getParentLanguage(language)] || LOGOTYPES.en;

const isWideTextLanguage = (language) => !NARROW_TEXT_LANGUAGES.includes(getParentLanguage(language));

const getHreflangs = (pageName, cmsLanguagesData) => {
  let availableLanguageVersions;

  if (cmsLanguagesData && cmsLanguagesData.length) {
    availableLanguageVersions = cmsLanguagesData
      .map((item) => item.full_slug.split("/")[0])
      .reduce((obj, item) => {
        const language = languages.get(item);
        if (!language || language.hidden) return obj;

        const cmsObj = obj;
        cmsObj[item] = language.name;

        return cmsObj;
      }, {});
  } else {
    availableLanguageVersions = Object.fromEntries(
      [...languages.entries()].filter((language) => checkIfPagePathExist(language[0], pageName))
    );
  }

  const hreflangs = buildLanguageData(availableLanguageVersions, pageName, cmsLanguagesData);

  return hreflangs;
};

export { getLocalizedLogotypes, isWideTextLanguage, getHreflangs };
